export default __webpack_public_path__ + "static/media/dahsboard-icon.afbdfadb.svg";